import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'GuidePage',
    component: () => import('../views/GuidePage.vue')
  },
  {
    path: '/ServiceContract',
    name: 'ServiceContract',
    component: () => import('../views/ServiceContract.vue')
  },
  {
    path: '/ProtectContract',
    name: 'ProtectContract',
    component: () => import('../views/ProtectContract.vue')
  }
]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  base: '/about',
  routes
})

export default router
